const RoutePaths = {
    // public
    home: '/',
    decode: "/decode",
    routine: "/routine",
    remedies: "/remedies",
    impact: "/impact",
    
    aboutUs: '/about-us',
    contactUs: '/contact-us',

    // private
};


export {
    RoutePaths
}
